import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";

import { restorePickZone } from "@/api/pick-zones-api";
import { type PickZone } from "@/schemas";

import { PICK_ZONES_QUERY_KEY } from "./use-pick-zones";
import { PICK_ZONE_CONFIGURATION_HISTORY_QUERY_KEY } from "./use-pick-zone-configuration-history";

export const useRestorePickZone = () => {
	const intl = useIntl();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ pickZoneId, data }: { pickZoneId: string; data: PickZone }) => {
			await restorePickZone(pickZoneId, data, intl);

			await queryClient.refetchQueries({ queryKey: [PICK_ZONES_QUERY_KEY] });
			await queryClient.refetchQueries({ queryKey: [PICK_ZONE_CONFIGURATION_HISTORY_QUERY_KEY] });
		},
	});
};
